import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import {
  Tabs as UnstyledTabs,
  TabList as UnstyledTabList,
  Tab,
  TabPanels,
  TabPanel as UnstyledTabPanel,
} from "@reach/tabs";
import "@reach/tabs/styles.css";
import Markdown from "markdown-to-jsx";
import { color, font } from "src/styles/variables";

function IntroTabs({
  introCopy,
  learnMoreTabText = "Learn more",
  learnMoreCopy,
}) {
  return (
    <Tabs defaultIndex={0}>
      <TabList>
        <Tab>Product details</Tab>
        {learnMoreCopy && <Tab>{learnMoreTabText}</Tab>}
      </TabList>
      <TabPanels>
        <TabPanel>
          <Markdown>{introCopy}</Markdown>
        </TabPanel>
        {learnMoreCopy && (
          <TabPanel>
            <Markdown>{learnMoreCopy}</Markdown>
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
}

IntroTabs.propTypes = {
  introCopy: PropTypes.string.isRequired,
  learnMoreCopy: PropTypes.string,
  learnMoreTabText: PropTypes.string,
};

export default IntroTabs;

const Tabs = styled(UnstyledTabs)`
  width: 100%;
  color: ${color.grey};
  margin-top: 30px;
  margin-bottom: 20px;
`;
Tabs.tabsRole = "Tabs";

const TabList = styled(UnstyledTabList)`
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  & button {
    font-family: ${font.primary};
    font-size: 16px;
    background: none;
    background-color: ${color.silverGrey};
    border: none;
    font-weight: 400;
    cursor: pointer;
    transition: 0.2s background-color, 0.2s font-weight;
    flex: 1;
    text-align: center;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    :not(:only-child) {
      cursor: pointer;
    }
    :first-child {
      border-top-left-radius: 5px;
    }
    :last-child {
      border-top-right-radius: 5px;
    }
  }
  & button[data-selected] {
    font-weight: 600;
    background-color: ${color.lightGrey};
    border-bottom-color: ${color.silverGrey};
  }
`;
TabList.tabsRole = "TabList";

const TabPanel = styled(UnstyledTabPanel)`
  padding: 20px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: ${color.lightGrey};
  & ul {
    list-style: disc;
    margin-left: 1em;
  }
`;
TabPanel.tabsRole = "TabPanel";
